import type { VariantProps } from 'class-variance-authority';

import type { DialogBorderPosition } from '@/app/components/overlays/utils/types';
import { cn } from '@/app/utils/cn';
import { cnva } from '@/app/utils/cnva';

export const ModalStyled = cnva(
  [
    'rounded-0 scroll-allow fixed inset-0 z-50 m-auto flex size-full flex-col will-change-transform outline-none',
    'xl:h-fit xl:w-full xl:rounded-sm',
  ],
  {
    variants: {
      theme: {
        light: 'bg-white text-gray-700',
        dark: 'bg-gray-900 text-gray-50',
      },
      sizes: {
        sm: 'xl:max-w-120',
        md: 'xl:max-w-164',
        lg: 'xl:max-w-256',
      },
      shadow: {
        true: 'drop-shadow-lg',
        false: '',
      },
    },
    defaultVariants: {
      theme: 'light',
      sizes: 'md',
      shadow: false,
    },
  }
);

export function getBorderClass(
  hasBorder = true,
  section: DialogBorderPosition,
  theme: VariantProps<typeof ModalStyled>['theme'] = 'light'
): string {
  if (!hasBorder) return '';

  return cn('before:pointer-events-none before:absolute before:inset-0', {
    'before:border-b': section === 'header',
    'before:border-t': section === 'footer',
    'before:border-gray-50': theme === 'light',
    'before:border-gray-700': theme === 'dark',
  });
}
